import { useHover } from "@mantine/hooks"

import { Tooltip } from "@tfg/ui"

import { NavItem } from "../../layout/NavBar/AppNavBar"

import styles from "./NavBarItem.module.css"

type Props = {
  item: NavItem
}

export const NavBarItem = ({ item }: Props) => {
  const { ref, hovered } = useHover<HTMLDivElement>()

  return (
    <Tooltip label={item.label} position="right">
      <div
        ref={ref}
        onClick={item.onClick}
        className={`${styles.navItem} ${item.isActive ? styles.active : ""}`}
      >
        <item.Icon width={28} hovered={item.isActive || hovered} />
      </div>
    </Tooltip>
  )
}
